var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 126.179,
    height: 125.266,
    viewBox: "0 0 126.179 125.266",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_167",
    "data-name": "Grupo 167",
    transform: "translate(-941.987 -370.76)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun-art-4489960"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_603",
    "data-name": "Caminho 603",
    d: "M1004.719,432.028a10.608,10.608,0,1,0,7.792,2.294A10.607,10.607,0,0,0,1004.719,432.028Zm7.533,9.865a6.438,6.438,0,1,1-2.094-4.1A6.438,6.438,0,0,1,1012.252,441.893Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_603-2",
    "data-name": "Caminho 603",
    d: "M967.4,410.632a10.608,10.608,0,1,0,7.792,2.294A10.608,10.608,0,0,0,967.4,410.632Zm7.533,9.865a6.438,6.438,0,1,1-2.094-4.1A6.437,6.437,0,0,1,974.935,420.5Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_604",
    "data-name": "Caminho 604",
    d: "M967.476,470.247a10.8,10.8,0,0,0,1.137-.061,10.613,10.613,0,1,0-1.137.061Zm-.682-17.018c.234-.023.463-.035.69-.035a6.432,6.432,0,1,1-.69.035Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_606",
    "data-name": "Caminho 606",
    d: "M999.406,410.572a12.743,12.743,0,1,0-8.843-3.583,12.743,12.743,0,0,0,8.843,3.583Zm-.9-21.273h0a9.091,9.091,0,0,1,.919-.047,8.563,8.563,0,1,1-.919.048Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_607",
    "data-name": "Caminho 607",
    d: "M975.982,495.4a13.583,13.583,0,0,0,13-9.177c5.779-14.182,24.62-19.527,24.963-19.628h0a127.786,127.786,0,0,1,14.069-3.754l1.083,25.99h0a7.489,7.489,0,0,0,14.966,0l1.251-30.14a33.737,33.737,0,0,0,22.8-29.643,48.376,48.376,0,0,0-8.026-29.008,2.085,2.085,0,1,0-3.52,2.236,44.21,44.21,0,0,1,7.394,26.488,29.616,29.616,0,0,1-18.443,25.459l.4-9.735h0a10.561,10.561,0,0,0,.864-20.691l.449-10.776h0A2.062,2.062,0,0,0,1049.05,411v-8.652a2.056,2.056,0,0,0-1.788-2.025,13.1,13.1,0,0,0,1.668-8.641c-1.038-8.91-9.036-19.778-11.676-20.683a2.091,2.091,0,0,0-1.46.035,17.08,17.08,0,0,0-4.713,4.975,71.132,71.132,0,0,0-36.027-4.647c-20.864,2.584-35.925,12.731-44.768,30.157-13.392,26.388-8.07,62.313-1.46,74.171,6.465,11.6,17.728,19.722,27.156,19.719Zm70.617-67.3a6.389,6.389,0,0,1-.5,12.075Zm-6.7,60.561a3.318,3.318,0,0,1-6.632,0l-3.145-75.6h12.932Zm4.968-79.765H1028.3v-4.469h16.566Zm-8.309-33.2c2.53,2.814,8.428,11.316,8.314,18.172h0a7.507,7.507,0,0,1-3.208,6.388h-10.151a7.594,7.594,0,0,1-3.214-6.465c-.086-6.894,5.873-15.4,8.261-18.1Zm-82.552,27.7c8.167-16.111,22.16-25.5,41.56-27.9a67.128,67.128,0,0,1,33.21,4.068,32,32,0,0,0-4.574,12.5,12.955,12.955,0,0,0,1.739,8.248,2.058,2.058,0,0,0-1.808,2.03v8.64a2.059,2.059,0,0,0,1.812,2.029l1.9,45.585h0a142.393,142.393,0,0,0-15.148,4.032c-.855.234-21.009,5.912-27.571,22.03a9.383,9.383,0,0,1-8.426,6.551c-8.057.486-18.385-7.064-24.234-17.559-6.056-10.872-11.005-45.523,1.542-70.25Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_608",
    "data-name": "Caminho 608",
    d: "M1055.817,394.865a2.086,2.086,0,1,1-2.086-2.086h0a2.086,2.086,0,0,1,2.086,2.086",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArt);
export default __webpack_public_path__ + "static/media/art.befb8d04d9f3e53c77d8eb5e01995c98.svg";
export { ForwardRef as ReactComponent };